import React from 'react';
import PartWrapper from '/react4xp/mixins/ui/part-wrapper';

import './api-service-info.scss';
import ApiTemplate from '/react4xp/mixins/api-template/api-template';
import { templates } from '/react4xp/mixins/api-template/template';

const ApiServiceInfo = (props: any) => {
    const { translations, pdf } = props;
    const { moduleName } = props.config;

    const templateData = templates(translations, moduleName);

    const handleBack = () => {
        window.location.href = `/${props.language}/pages/api-services`;
    };

    return (
        <ApiTemplate
            {...props}
            {...templateData}
            setIsActive={handleBack}
            translations={translations}
            commonTranslations={translations}
            pdf={pdf}
        />
    );
};

export default (props) => (
    <PartWrapper {...props}>
        <ApiServiceInfo {...props} />
    </PartWrapper>
);
